import { validarCampos } from "./ValidadorDeCampos";

/**
 * Cria o handler dos campos select de múltipla escolha (TextField multiple).
 *
 * Grava no state apenas os ids selecionados e revalida somente o campo alterado,
 * seguindo o mesmo comportamento dos handlers de select simples das telas.
 *
 * @param state         objeto de filtro atual
 * @param setState      setter do objeto de filtro
 * @param campos        lista de objCampo usada na validação (opcional)
 * @param errors        objeto de erros atual (opcional)
 * @param setErrors     setter do objeto de erros (opcional)
 * @param aoAlterar     callback (novoState, e) => camposExtras | null, para efeitos
 *                      colaterais e para limpar campos dependentes na mesma
 *                      atualização de state, evitando que um setState posterior
 *                      sobrescreva a limpeza
 */
export const criarOnChangeMultiSelect = ({ state, setState, campos = [], errors = {}, setErrors, aoAlterar }) =>
    (values, e) => {
        const _state = {
            ...state,
            [e.name]: (values ?? []).map(item => item.value),
        };

        if (aoAlterar) {
            const camposExtras = aoAlterar(_state, e);
            if (camposExtras)
                Object.assign(_state, camposExtras);
        }

        if (setErrors) {
            const _campos = campos.filter(campo => campo.name === e.name);
            const fieldError = validarCampos(_state, _campos);

            const _errors = { ...errors };
            delete _errors[e.name];

            setErrors(fieldError[1].length === 0
                ? { ..._errors }
                : { ..._errors, ...fieldError[0] });
        }

        setState(_state);
    };
